import { render, staticRenderFns } from "./AudioAssets.vue?vue&type=template&id=66fb3060"
import script from "./AudioAssets.vue?vue&type=script&lang=js"
export * from "./AudioAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports